import { motion } from 'framer-motion';
import { containerVariants, fadeUpVariants } from '../lib/motion';
import { DASHBOARD_FEATURES } from '../mock';

export default function Dashboard() {
  return (
    <section className="section-pad bg-brand-dark text-brand-cream relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-green/20 rounded-full blur-3xl -z-0" />
      
      <motion.div 
        variants={containerVariants(0.08)}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        className="relative max-w-7xl mx-auto px-6 lg:px-12"
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Column - Image */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="lg:col-span-6 rounded-3xl overflow-hidden border border-brand-cream/10 shadow-2xl bg-brand-deep/30"
          >
            <img 
              src="/admin_dashboard_mockup.png" 
              alt="One connected platform architecture" 
              className="w-full h-auto block" 
            />
          </motion.div>

          {/* Right Column - Stacked Content */}
          <div className="lg:col-span-6 flex flex-col justify-center">
            <div className="mb-8">
              <h2 className="heading-display text-3xl md:text-5xl text-left leading-tight">One Technology Stack. Powering Every Mobility Service.</h2>
              <p className="mt-4 text-brand-cream/70 text-left">Connecting vehicles, operations, and partners on one integrated platform.</p>
            </div>

            <div className="space-y-4">
              {DASHBOARD_FEATURES.map(({ icon: Icon, title, desc }) => (
                <div 
                  key={title} 
                  className="flex gap-4 p-4 rounded-2xl bg-brand-deep/30 border border-brand-cream/5 hover:border-brand-lime/20 transition-all duration-300"
                >
                  <div className="w-10 h-10 shrink-0 rounded-lg bg-brand-lime text-brand-dark flex items-center justify-center shadow-md">
                    <Icon size={18} />
                  </div>
                  <div>
                    <h4 className="heading-display text-base font-semibold text-brand-cream">{title}</h4>
                    <p className="text-sm text-brand-cream/65 mt-1 leading-relaxed">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
